import styles from './VerticalSystemCircle.module.scss';

import cx from 'classnames';
import React from 'react';
import { FlatResponsiveImage } from 'components/FlatResponsiveImage/FlatResponsiveImage';
import { Image } from 'components/Image/Image';
import { TextV2 } from 'components/TextV2/TextV2';
import { useBreakpoints } from 'hooks/useBreakpoints';
import cloverIcon from 'images/icons/clover-logo-purple-circle.svg';
import { useVerticalSystemContext } from '../VerticalSystemContext/VerticalSystemContext';

export const VerticalSystemCircle = () => {
  const { activeTabItem, activeVariant, setActiveVariant } = useVerticalSystemContext();
  const { browser } = useBreakpoints();
  const isDesktopOrLarge = browser.is.desktop;
  const circleRadius = isDesktopOrLarge ? 600 : 412;

  if (!activeTabItem) return null;

  return (
    <div className={styles.root}>
      <div className={styles.circles}>
        <svg viewBox={`0 0 ${circleRadius * 2} ${circleRadius * 2}`} xmlns="http://www.w3.org/2000/svg">
          {activeTabItem.items.map((_, index, arr) => {
            const variant = arr.at(arr.length - index - 1)?.variant;
            const isActive = activeVariant === variant;
            return (
              <circle
                key={variant}
                className={cx(isActive && styles.active)}
                cx={circleRadius}
                cy={circleRadius + (isDesktopOrLarge ? 0 : index * 25)}
                r={circleRadius - 2 - index * (isDesktopOrLarge ? 131 : 89)}
                role="presentation"
                onClick={() => setActiveVariant(variant)}
              />
            );
          })}
        </svg>
      </div>
      <div className={styles.gradient} />
      <Image className={styles.cloverIcon} src={cloverIcon} alt="" />
      <ul className={styles.list}>
        {activeTabItem.items.map(({ itemTitle, icon, variant }) => {
          const isActive = activeVariant === variant;
          return (
            <li key={variant} className={cx(styles.listItem, isActive && styles.active)}>
              <button className={styles.listButton} onClick={() => setActiveVariant(variant)} type="button">
                <FlatResponsiveImage
                  className={styles.listIcon}
                  image={icon}
                  isLazyLoad={false}
                  pictureProps={{ className: styles.listIcon }}
                />
                <div className={styles.listTexts}>
                  <TextV2
                    aria-hidden="true"
                    className={cx(styles.listTextSmall, !isActive && styles.show)}
                    value={itemTitle}
                    variant="modern-body"
                  />
                  <TextV2
                    className={cx(styles.listTextLarge, isActive && styles.show)}
                    value={itemTitle}
                    variant="modern-body-large-medium"
                  />
                </div>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
